// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3WVwJ","unreadBadge":"styles_unreadBadge__31kHa","modalContent":"styles_modalContent__3t4Bb","modal":"styles_modal__37WnA"};